import { useEffect } from 'react';

const SITE_URL = 'https://77gestao.com.br';
const DEFAULT_IMAGE = `${SITE_URL}/logo/logo-single.png`;

interface SEOOptions {
  title: string;
  description: string;
  canonical: string;
  image?: string;
  jsonLd?: object | object[];
}

function setMeta(selector: string, attr: string, value: string) {
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    const [attrName, attrValue] = selector.replace(/[[\]"]/g, ' ').trim().split(/\s+/);
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel: string, href: string) {
  let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

function setJsonLd(id: string, data: object | object[]) {
  let el = document.querySelector<HTMLScriptElement>(`script[data-seo="${id}"]`);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute('data-seo', id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(Array.isArray(data) ? data : data);
}

export function useSEO({ title, description, canonical, image = DEFAULT_IMAGE, jsonLd }: SEOOptions) {
  useEffect(() => {
    const fullUrl = canonical.startsWith('http') ? canonical : `${SITE_URL}${canonical}`;

    document.title = title;

    setMeta('meta[name="description"]', 'content', description);
    setLink('canonical', fullUrl);

    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', fullUrl);
    setMeta('meta[property="og:image"]', 'content', image);

    setMeta('meta[property="twitter:title"]', 'content', title);
    setMeta('meta[property="twitter:description"]', 'content', description);
    setMeta('meta[property="twitter:url"]', 'content', fullUrl);
    setMeta('meta[property="twitter:image"]', 'content', image);

    if (jsonLd) setJsonLd('page', jsonLd);

    return () => {
      document.querySelector('script[data-seo="page"]')?.remove();
    };
  }, [title, description, canonical, image, jsonLd]);
}
